export const IFAST_ACCOUNT_MOVEMENT_OPTIONS = [
  { value: "AUM_TRANSFER_IN", label: "AUM Transfer In 資產轉入" },
  { value: "AUM_TRANSFER_OUT", label: "AUM Transfer Out 資產轉出" },
  { value: "CASH_WITHDRAWAL", label: "Cash Withdrawal 現金提取" },
  {
    value: "INTERNAL_CASH_TRANSFER",
    label: "Internal Cash Transfer 內部現金轉賬",
  },
  {
    value: "INTERNAL_HOLDING_TRANSFER",
    label: "Internal Holding Transfer 內部持倉轉賬",
  },
];

const MOVEMENT_TYPES = IFAST_ACCOUNT_MOVEMENT_OPTIONS.map((option) => option.value);
const VALUE_TYPES = ["CASH_WITHDRAWAL"];

export const ifastAccountMovementLabel = (type) =>
  IFAST_ACCOUNT_MOVEMENT_OPTIONS.find((option) => option.value === type)?.label ??
  "";

export const ifastAccountMovementLabelParts = (type) => {
  const label = ifastAccountMovementLabel(type);
  const splitAt = label.search(/\s+[\u3400-\u9fff]/);
  if (splitAt < 0) return { en: label, zh: "" };
  return {
    en: label.slice(0, splitAt).trim(),
    zh: label.slice(splitAt).trim(),
  };
};

export const showsMovementValueFields = (type) => VALUE_TYPES.includes(type);

export const showsNetContribution = (type) => type === "CASH_WITHDRAWAL";

const emptyToNull = (value) => {
  if (value === "" || value == null) return null;
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
};

const round2 = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return null;
  const shifted = Math.round((Math.abs(num) + 1e-8) * 100);
  return (Math.sign(num) * shifted) / 100;
};

const normalizeCurrency = (value) => {
  const code = String(value ?? "").trim().toUpperCase();
  return code || "HKD";
};

export const emptyWithdrawalLine = () => ({
  currency: "HKD",
  withdrawalAmount: null,
});

export const buildExternalRateMap = (source) => {
  const map = { HKD: 1 };
  const list = Array.isArray(source) ? source : source?.rates;
  if (!Array.isArray(list)) return map;
  list.forEach((row) => {
    const code = normalizeCurrency(row?.code);
    const value = Number(row?.externalValue);
    if (!code || !Number.isFinite(value) || value <= 0) return;
    map[code] = value;
  });
  map.HKD = 1;
  return map;
};

const lineWithdrawalAmount = (line) => {
  const amount = emptyToNull(line?.withdrawalAmount);
  if (amount != null) return amount;
  return emptyToNull(line?.totalCurrentValue);
};

const lineHasAmount = (line) => lineWithdrawalAmount(line) != null;

const normalizeWithdrawalLine = (line) => ({
  currency: normalizeCurrency(line?.currency),
  withdrawalAmount: lineWithdrawalAmount(line),
});

export const missingWithdrawalCurrencies = (lines, rateMap = {}) => {
  const missing = [];
  (Array.isArray(lines) ? lines : []).forEach((line) => {
    if (!lineHasAmount(line)) return;
    const code = normalizeCurrency(line.currency);
    if (rateMap[code] == null && !missing.includes(code)) missing.push(code);
  });
  return missing;
};

const withdrawalLinesFromSource = (source) => {
  if (!Array.isArray(source.withdrawalLines)) return [];
  return source.withdrawalLines.map(normalizeWithdrawalLine).filter(lineHasAmount);
};

export const sumWithdrawalAmountHkd = (lines, rateMap = {}) => {
  const missing = missingWithdrawalCurrencies(lines, rateMap);
  if (missing.length) return { total: null, missing };
  let total = 0;
  let any = false;
  (Array.isArray(lines) ? lines : []).forEach((line) => {
    const amount = lineWithdrawalAmount(line);
    if (amount == null) return;
    const rate = rateMap[normalizeCurrency(line.currency)];
    total += round2(amount * rate);
    any = true;
  });
  return { total: any ? round2(total) : null, missing };
};

export const withdrawalAmountInHkd = (line, rateMap = {}) => {
  const amount = lineWithdrawalAmount(line);
  if (amount == null) return null;
  const rate = rateMap[normalizeCurrency(line?.currency)];
  if (rate == null) return null;
  return round2(amount * rate);
};

export const emptyIfastAccountMovement = () => ({
  date: null,
  type: "",
  totalCurrentValue: null,
  totalProfitLoss: null,
  netContribution: null,
  withdrawalLines: [],
});

export const ensureWithdrawalDraftLines = (row = {}) => {
  if (row.type !== "CASH_WITHDRAWAL") return row;
  if (Array.isArray(row.withdrawalLines) && row.withdrawalLines.length) return row;
  return { ...row, withdrawalLines: [emptyWithdrawalLine()] };
};

export const sanitizeIfastAccountMovement = (row = {}) => {
  const type = MOVEMENT_TYPES.includes(row.type) ? row.type : "";
  const isWithdrawal = showsMovementValueFields(type);
  const lines = isWithdrawal ? withdrawalLinesFromSource(row) : [];
  const next = {
    date: row.date ?? null,
    type,
    totalCurrentValue: isWithdrawal ? emptyToNull(row.totalCurrentValue) : null,
    totalProfitLoss: isWithdrawal ? emptyToNull(row.totalProfitLoss) : null,
    netContribution: isWithdrawal ? emptyToNull(row.netContribution) : null,
    withdrawalLines: lines,
  };
  if (row._id) next._id = row._id;
  return next;
};
